import PocketBase from 'pocketbase';

// ── Where your PocketBase server lives ─────────────────────────────
// This is the address of the PocketBase server running on your VPS.
// Change DEFAULT_URL to your real address once the server is set up,
// e.g. 'https://denim-api.trombayy.tech'.
//
// For local development you can override it without touching this file
// by running in the browser console:  localStorage.setItem('pbUrl', 'http://127.0.0.1:8090')
const DEFAULT_URL =
  process.env.REACT_APP_PB_URL || 'https://denim.trombayy.tech';

export const PB_URL = localStorage.getItem('pbUrl') || DEFAULT_URL;

const pb = new PocketBase(PB_URL);

// Keep concurrent requests from auto-cancelling each other (we fire
// several reads/writes in parallel across the app).
pb.autoCancellation(false);

// Convenience helpers used across the app.
export function currentUser() {
  return pb.authStore.record || pb.authStore.model || null;
}

export function isLoggedIn() {
  return pb.authStore.isValid;
}

export function currentRole() {
  const u = currentUser();
  return u?.role || 'user';
}

export default pb;
